import { Routes, Route, useNavigate } from "react-router-dom"
import { Container, Fade, Box } from "@mui/material";
import CompanyPage from "./CompanyPage"
// import { SlideInContextProvider } from "ft-shared-graphql";
import AppBar from "../components/AppBar"
import { ViewAnswersPage } from "../AnswerPages/ViewAnswersPage";
import CompanyStatsPage from "./CompanyStatsPage";
// import { SlideIn } from "ft-shared-graphql";
import CompanyStudentInsights from "./CompanyStudentStats";

const CompanyPageRoutes = () => {
    const navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }
    return (
        <Routes>
            <Route path="/" element={<CompanyPage onBack={goBack} />} />
            <Route path="/answers" element={<ViewAnswersPage onBack={goBack} />} />
            <Route path="/stats" element={<CompanyStatsPage onBack={goBack} />} />
            <Route path="/students" element={<CompanyStudentInsights onBack={goBack} />} />

            {/* <Route path="/staff" element={<ViewAllStaff onBack={goBack} />} /> */}
        </Routes>
    )
}
export const CompanyRoutes = () => {
    return (
        <Fade in={true}>
            <Box component="div">
                {/* <SlideInContextProvider> */}
                    <div>
                        {/* <SlideIn /> */}
                        <AppBar />
                    </div>
                    <Container maxWidth="xl">
                        <Box component="div" sx={{ paddingTop: "40px", paddingBottom: "32px" }}>
                            <Routes>
                                <Route path="/:id/*" element={<CompanyPageRoutes />} />
                            </Routes>
                        </Box>
                    </Container>
                {/* </SlideInContextProvider> */}
            </Box>
        </Fade>
    )
}